export default __webpack_public_path__ + "media/color/rep-4cdb5b02.svg";